/**
 * IntelliGems A/B Test: Open capsule-form collection filters
 *
 * Control (A): data-collection-capsule-filters="false"
 * Variant (B): data-collection-capsule-filters="true"
 *
 * Dev preview: ?collection_capsule_filters_test=b
 *
 * Sort + availability pills update products via the theme CollectionSection
 * Ajax reload (no full page refresh).
 */
(function () {
  'use strict';

  if (window.__collectionCapsuleFiltersABTestInit) return;
  window.__collectionCapsuleFiltersABTestInit = true;

  var BODY_ATTR = 'data-collection-capsule-filters';
  var applying = false;
  var debounceTimer = null;
  var variantActive = null;
  var abortController = null;

  function isDevVariantB() {
    try {
      return new URLSearchParams(window.location.search).get('collection_capsule_filters_test') === 'b';
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;

    var body = document.body;
    var html = document.documentElement;
    if (!body || !html) return false;

    return body.getAttribute(BODY_ATTR) === 'true' ||
      html.getAttribute(BODY_ATTR) === 'true';
  }

  function applyVariant() {
    if (applying) return;
    applying = true;

    try {
      var variantB = isVariantB();
      if (variantB === variantActive) return;

      variantActive = variantB;
      document.documentElement.classList.toggle('collection-capsule-filters-b', variantB);
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyVariant, 40);
  }

  function getCollectionSection() {
    var el = document.querySelector('[data-section-type="collection"]');
    return el && el.__collectionSectionInstance ? el.__collectionSectionInstance : null;
  }

  function getSectionId(sectionInstance) {
    if (sectionInstance && sectionInstance.settings && sectionInstance.settings.sectionId) {
      return sectionInstance.settings.sectionId;
    }

    var el = document.querySelector('[data-section-type="collection"]');
    if (!el) return null;

    try {
      var settings = JSON.parse(el.getAttribute('data-section-settings') || '{}');
      if (settings.sectionId) return settings.sectionId;
    } catch (e) {}

    return el.getAttribute('data-section-id');
  }

  function buildSortUrl(sortBy) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortBy);
    url.searchParams.delete('page');
    return url.pathname + url.search + url.hash;
  }

  function updateCapsuleFiltersFromHtml(sectionEl, tempElement) {
    var newCapsuleFilters = tempElement.querySelector('[data-collection-capsule-filters-root]');
    var currentCapsuleFilters = sectionEl.querySelector('[data-collection-capsule-filters-root]');

    if (newCapsuleFilters && currentCapsuleFilters) {
      currentCapsuleFilters.replaceWith(newCapsuleFilters);
    } else if (newCapsuleFilters && !currentCapsuleFilters) {
      var collectionMain = sectionEl.querySelector('.CollectionMain');
      var collectionInner = sectionEl.querySelector('.CollectionInner');
      if (collectionMain && collectionInner) {
        collectionMain.insertBefore(newCapsuleFilters, collectionInner);
      }
    } else if (!newCapsuleFilters && currentCapsuleFilters) {
      currentCapsuleFilters.remove();
    }
  }

  function updateSidebarFilters(sectionEl, tempElement) {
    var collectionFiltersDrawer = sectionEl.querySelector('#collection-filters-drawer-form');
    var collectionFiltersSidebar = sectionEl.querySelector('#collection-filters-sidebar-form');

    if (collectionFiltersDrawer) {
      var newDrawerContent = tempElement.querySelector('#collection-filters-drawer-form');
      if (newDrawerContent) {
        collectionFiltersDrawer.innerHTML = newDrawerContent.innerHTML;
      }
    }

    if (collectionFiltersSidebar) {
      var newSidebarContent = tempElement.querySelector('#collection-filters-sidebar-form');
      if (newSidebarContent) {
        collectionFiltersSidebar.innerHTML = newSidebarContent.innerHTML;
      }
    }

    var toolbarFilter = tempElement.querySelector('.CollectionToolbar__Item--filter');
    if (toolbarFilter) {
      var currentToolbarFilter = sectionEl.querySelector('.CollectionToolbar__Item--filter');
      if (currentToolbarFilter) {
        currentToolbarFilter.innerHTML = toolbarFilter.innerHTML;
        currentToolbarFilter.className = toolbarFilter.className;
      }
    }
  }

  function fallbackAjaxReload(url) {
    var sectionEl = document.querySelector('[data-section-type="collection"]');
    var sectionId = getSectionId(null);
    var productsEl = sectionEl && sectionEl.querySelector('.CollectionInner__Products');

    if (!sectionEl || !sectionId || !productsEl) {
      window.location.href = url;
      return;
    }

    if (abortController) {
      abortController.abort();
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    if (history.replaceState) {
      window.history.pushState({ path: url }, '', url);
    }

    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    abortController = new AbortController();

    fetch(fetchUrl.toString(), { signal: abortController.signal })
      .then(function (response) {
        return response.text();
      })
      .then(function (content) {
        var tempElement = document.createElement('div');
        tempElement.innerHTML = content;

        var newProducts = tempElement.querySelector('.CollectionInner__Products');
        if (newProducts) {
          productsEl.innerHTML = newProducts.innerHTML;
        }

        updateCapsuleFiltersFromHtml(sectionEl, tempElement);
        updateSidebarFilters(sectionEl, tempElement);

        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        var collectionMain = sectionEl.querySelector('.CollectionMain');
        if (collectionMain) {
          var headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'), 10) || 0;
          var elementOffset = collectionMain.getBoundingClientRect().top - headerHeight;
          if (elementOffset < 0) {
            window.scrollBy({ top: elementOffset, behavior: 'smooth' });
          }
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;
        window.location.href = url;
      });
  }

  function reloadProducts(url) {
    var section = getCollectionSection();

    if (section && typeof section._reloadProducts === 'function') {
      section._reloadProducts(url);
      return;
    }

    fallbackAjaxReload(url);
  }

  function onCapsuleClick(event) {
    if (!isVariantB()) return;

    var sortPill = event.target.closest('[data-collection-capsule-sort]');
    if (sortPill) {
      event.preventDefault();

      var sortBy = sortPill.getAttribute('data-collection-capsule-sort');
      if (!sortBy) return;

      var root = sortPill.closest('[data-collection-capsule-filters-root]');
      if (root) {
        root.querySelectorAll('[data-collection-capsule-sort]').forEach(function (node) {
          var isActive = node === sortPill;
          node.classList.toggle('is-active', isActive);
          node.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      reloadProducts(buildSortUrl(sortBy));
      return;
    }

    var linkPill = event.target.closest('[data-collection-capsule-filters-root] a.collection-capsule-filters-ab__pill');
    if (!linkPill) return;

    if (linkPill.classList.contains('is-disabled') || linkPill.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    var href = linkPill.getAttribute('href');
    if (!href) return;

    var targetUrl;
    try {
      targetUrl = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    // Quick links to a different collection still do a normal navigation
    if (targetUrl.pathname !== window.location.pathname) return;

    event.preventDefault();
    reloadProducts(targetUrl.pathname + targetUrl.search + targetUrl.hash);
  }

  function init() {
    if (isDevVariantB()) {
      if (document.documentElement.getAttribute(BODY_ATTR) !== 'true') {
        document.documentElement.setAttribute(BODY_ATTR, 'true');
      }
      if (document.body && document.body.getAttribute(BODY_ATTR) !== 'true') {
        document.body.setAttribute(BODY_ATTR, 'true');
      }
    }

    applyVariant();
    document.addEventListener('click', onCapsuleClick);

    if (!document.body) return;

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === BODY_ATTR ||
          mutations[i].attributeName === 'data-gem-variant' ||
          mutations[i].attributeName === 'data-gem-test-active') {
          scheduleApply();
          return;
        }
      }
    }).observe(document.body, {
      attributes: true,
      attributeFilter: [BODY_ATTR, 'data-gem-variant', 'data-gem-test-active']
    });

    document.addEventListener('gem:variant:changed', scheduleApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
